<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <app-title>Commissions Suppressed</app-title>
        <commissions-runs @runSelected="chooseRun" :disabled="deleted"></commissions-runs>
        <v-checkbox label="Show Deleted" v-model="deleted" :value="true"></v-checkbox>
        <commissions-suppress
          :details="details"
          :runType="run.runType"
          :runId="run.runId"
          @saved="loadData"
          @edited="loadData"
        ></commissions-suppress>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import commissionSuppress from "@/components/commissions/commissionSuppress";
import commsRuns from "@/components/app/commsRuns";
import { mapActions, mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
export default {
  name: "commissionsSuppressed",
  data () {
    return {
      deleted: false,
      details: [],
      storedRunID: 0,
    };
  },
  components: {
    "commissions-suppress": commissionSuppress,
    "commissions-runs": commsRuns
  },
  computed: {
    ...mapState("commissions", ['run']),
    ...mapFields("commissions", ['run.runId', 'run.runType']),
  },
  mounted () {
    let vm = this;
    if (this.run.runId && this.run.runType)
      vm.loadData();
  },
  watch: {
    deleted: function (val) {
      if (val) {
        this.storedRunID = this.runId;
        this.runId = 0;
      }
      else
        this.runId = this.storedRunID;
      this.loadData();
    },
  },
  methods: {
    ...mapActions("commissions", ["CommissionsRequest"]),
    chooseRun () {
      this.loadData();
    },
    loadData () {
      let vm = this;
      if (vm.runId >= 0) {
        let query = {
          message: "Suppressed Customers loaded",
          url: `Commissions/GetSuppressed/${vm.runId}/${vm.runType}`,
          method: "get",
          body: ""
        };
        this.CommissionsRequest(query)
          .then(data => {
            vm.details = data;
          })
          .catch(() => { });
      }
    }
  }
};
</script>

<style scoped>
</style>